import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import '@trustpilot/icons/dist/styles.css';
import { css, Global } from '@emotion/core';
import { Routes } from './routes/routes';
import { fonts, grid, GlobalAlert, GlobalAlertService, BannerAlert } from '@trustpilot/businessapp-patternlibrary';
import { Settings, Login } from './routes';
import { PrivateRoute } from './routes/common/auth';
import { Auth } from './routes/login/auth';
import { SettingsInformation } from './api/types';

const basename = '/v1';
const cookiesDomain = process.env.REACT_APP_CookiesDomain!;
const authenticationApiUrl = process.env.REACT_APP_AuthenticationApiUrl!;

interface AppProps {
  settings: SettingsInformation;
}

interface AppState {
  loggedIn: boolean | null;
}

class App extends React.Component<AppProps, AppState> {
  constructor(props: AppProps) {
    super(props);
    this.state = {
      loggedIn: null,
    };
  }

  componentDidMount() {
    Auth.isLoggedIn(authenticationApiUrl, cookiesDomain)
      .then((loggedIn: boolean) => {
        this.setState({ loggedIn });
      });
  }

  private onLoggedInChange = (loggedIn: boolean) => {
    if (!loggedIn) {
      GlobalAlertService.critical('Login failed!', 4200);
    }

    if (loggedIn) {
      this.setState({ loggedIn });
    }
  }

  public inIframe() {
    try {
      return window.self !== window.top;
    } catch (e) {
      return true;
    }
  }

  public hasSubdomain() {
    return this.props.settings && this.props.settings.subdomain;
  }

  public render() {
    const { loggedIn } = this.state;
    const { settings } = this.props;

    if (loggedIn === null) {
      // avoid rerenders and redirects until we are certain which route we should render
      return null;
    }

    if (!this.inIframe()) {
      return <BannerAlert>You've successfully integrated with Trustpilot. Please close the window.</BannerAlert>;
    }

    if (!this.hasSubdomain()) {
      return <BannerAlert appearance="warning">We've detected an issue. Please contact our support team.</BannerAlert>
    }

    return (
      <div>
        <GlobalAlert subscribe={GlobalAlertService.subscribe} unsubscribe={GlobalAlertService.unsubscribe} />
        <Global styles={GlobalStyles} />
        <BrowserRouter basename={basename}>
          <Switch>
            <Route exact={true} path={Routes.LOGIN} render={() => <Login isLoggedIn={loggedIn} onLoggedInChange={this.onLoggedInChange} />} />
            <PrivateRoute path={`${Routes.ADMIN_UI}/:integrationSecret`} isLoggedIn={loggedIn} render={() => <Settings settings={settings} />} />
            <PrivateRoute path={Routes.ADMIN_UI} isLoggedIn={loggedIn} render={() => <Settings settings={settings} />} />
          </Switch>
        </BrowserRouter>
      </div>
    );
  }
}

const GlobalStyles = css({
  body: {
    fontFamily: fonts.family,
  },
  '#root': {
    padding: grid.small,
  },
  '*': {
    boxSizing: 'border-box',
  },
  'textarea, input, select': {
    fontFamily: 'inherit',
    fontSize: 'inherit',
  }
});

export default App;
